import { withNaming } from '@bem-react/classname';

// eslint-disable-next-line import/prefer-default-export
export const cn = withNaming({ e: '__', m: '_', v: '_' });
